import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Btn } from "@/components/Btn";
import { CTA } from "@/lib/brand";
import { FlaskConical, Flame, Bomb, ShieldAlert, Syringe, Droplets, Phone } from "lucide-react";

const ITEMS = [
  { icon: FlaskConical, t: "Hazardous chemicals", d: "Solvents, pesticides and other nasty chemicals need special disposal we are not set up for." },
  { icon: Flame, t: "Propane tanks", d: "Those pressurized tanks are a no go for safety reasons. Your local exchange can help!" },
  { icon: Bomb, t: "Ammunition", d: "Anything explosive or ammo related has to be handled by the proper folks." },
  { icon: ShieldAlert, t: "Asbestos", d: "This one needs certified abatement pros. We will gladly point you in the right direction." },
  { icon: Syringe, t: "Medical waste", d: "Sharps and biohazard material require licensed medical disposal." },
  { icon: Droplets, t: "Loose liquids", d: "Open paint, oil and other liquids cannot ride in the truck. Dry it out and we can take the can!" },
];

export default function CantHaul() {
  return (
    <>
      <Seo path="/what-we-cant-haul" title="What We Cannot Haul" description="A short, friendly list of the few things Skedaddle Junk Removal cannot take, like hazardous chemicals, propane, ammo, asbestos, medical waste and liquids." />
      <PageHero eyebrow="Good to know" title="The short list we cannot haul." subtitle="We take almost everything! Here are the few exceptions, and they are all about keeping everyone safe." />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-5xl px-4 md:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {ITEMS.map((x) => (
              <div key={x.t} className="bg-cream border-2 border-charcoal rounded-3xl p-6 shadow-brut">
                <div className="w-14 h-14 rounded-2xl border-2 border-charcoal bg-coral text-cream flex items-center justify-center mb-4"><x.icon className="w-7 h-7" /></div>
                <h3 className="font-heading font-bold text-xl">{x.t}</h3>
                <p className="mt-2 font-body text-charcoal/70">{x.d}</p>
              </div>
            ))}
          </div>
          <div className="mt-10 bg-teal text-cream border-2 border-charcoal rounded-3xl p-8 shadow-brut text-center">
            <p className="font-body text-lg">Not sure if your item makes the list? Just ask! Give us a shout and we will tell you straight.</p>
            <div className="mt-5 flex flex-wrap justify-center gap-3">
              <Btn to="/contact" variant="accent" size="md">{CTA.quote}</Btn>
              <Btn href="tel:+18435180021" variant="white" size="md"><Phone className="w-5 h-5" /> Call us</Btn>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
